import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EmployeeRepository } from "@entity/data/repositories/employee.repository";
import { inject, injectable } from "inversify";

@injectable()
export class GetContractedHoursForPeriodUseCase {
    constructor(
        @inject(EmployeeRepository)
        private readonly employeeRepository: EmployeeRepository,
    ) {}

    async execute(
        employeeId: number,
        startDate: string,
        endDate: string,
    ): Promise<Nullable<number>> {
        const result =
            await this.employeeRepository.getContractedHoursForPeriod(
                employeeId,
                startDate,
                endDate,
            );

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
            return null;
        }

        return result.fold(
            () => null,
            (hours) => hours,
        );
    }
}
